import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import GoogleAnalyticsCustomDimensions from 'constants/googleAnalyticsCustomDimension';

const tdvEvents = 'TDV Events';

/* Creates a new instance of a community listing. */
export default class CommunityProductType {
  constructor(listing) {
    this.brandName = listing.brandName;
    this.name = listing.name;
    this.id = listing.id;
    this.isBasic = listing.isBasic === "true";
  }

  /**
   * This function returns a new GoogleAnalyticsEvent object with the event category, event action, and
   * event label set.
   * @returns A new instance of the GoogleAnalyticsEvent class.
   */
  getFavoriteGoogleAnalyticsEvent() {
    const customDimensions = { 
      [GoogleAnalyticsCustomDimensions.BrandName().getName()] :
      this.brandName,
      [GoogleAnalyticsCustomDimensions.CommunityName().getName()] :
      this.name,
      [GoogleAnalyticsCustomDimensions.CommunityId().getName()] :
      this.id,
      [GoogleAnalyticsCustomDimensions.IsPaid().getName()] : 
      !this.isBasic,
    };
    return new GoogleAnalyticsEvent(tdvEvents, 'SRP Listing Card', 'Listing Saved', customDimensions);
  }
}
